// extracted by mini-css-extract-plugin
module.exports = {"videoFrame":"assets_videoFrame__SCf3L"};